import axios from '../axios';

// @context TGW-2195 既定画像（AI生成）の判定と要求を index.js / section_subject.js で共用するために切り出す
//   （詳細設計 §3.9）。入口の「次へ」と基本ページのタイトル blur の両方から同じ条件で呼ぶ。
//   字数の下限15はタイトルの公開要件、上限100は既存の生成 API 側の制限に合わせている
//   （タイトル欄の入力上限60より広いのは、既存下書きに60超の題名が残り得るため）。
export const shouldGenerateDefaultImage = (event, title) =>
  !(event || {}).main_image_url_medium_strict &&
  !!title &&
  title.length >= 15 &&
  title.length <= 100;

export const requestDefaultImage = (eventId, title) =>
  axios
    .post(
      '/api/event/generate_default_image',
      JSON.stringify({ event_id: eventId, event_title: title })
    )
    .then((res) => res.data.main_image_url);

// @context TGW-2195 生成は非同期で数秒かかる。その間にユーザーがカバーを登録していたら、
//   遅れて返った既定画像で上書きしない（PR #2536 Copilot 指摘）。setEvent の updater に渡す。
export const withDefaultImage = (url) => (prev) =>
  prev.main_image_url_medium_strict ? prev : { ...prev, main_image_url_medium_strict: url };
